/* tslint:disable */
/* eslint-disable */
/**
 * Keyops CEP
 * Customer Engagement Platform API documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum QuestionTypeEnum {
    Consent = 'Consent',
    DateTime = 'DateTime',
    Dropdown = 'Dropdown',
    EmailInput = 'EmailInput',
    MultiChoice = 'MultiChoice',
    NumberInput = 'NumberInput',
    OpinionScale = 'OpinionScale',
    PhoneNumber = 'PhoneNumber',
    RankOrder = 'RankOrder',
    Rating = 'Rating',
    Slider = 'Slider',
    TextInput = 'TextInput',
    URLInput = 'URLInput',
    YesNo = 'YesNo',
    ContactForm = 'ContactForm',
    ConstantSum = 'ConstantSum',
    GroupRank = 'GroupRank',
    GroupRating = 'GroupRating',
    Matrix = 'Matrix',
    MaxDiff = 'MaxDiff'
}

